import { REMOVE_OPTIMISTIC_TROLLEY_ITEM } from './types';

export default lineNumber => ({
  type: REMOVE_OPTIMISTIC_TROLLEY_ITEM,
  lineNumber,
});
